export const toDecimal = (value) => {
  try {
    if (value === null || value === undefined) {
      return 0;
    }

    let num;

    if (typeof value === 'number') {
      num = Number.isFinite(value) ? value : 0;
    } else if (value instanceof Date) {
      num = 0;
    } else {
      let raw = String(value);
      raw = raw.replace(/,/g, '');
      raw = raw.replace(/[^0-9.\-]/g, '');

      if ((raw.match(/\./g) || []).length > 1) {
        const parts = raw.split('.');
        raw = parts[0] + '.' + parts.slice(1).join('');
      }

      const isNegative = raw.trim().startsWith('-');
      raw = raw.replace(/-/g, '');
      raw = (isNegative ? '-' : '') + raw;

      if (raw === '.' || raw === '-' || raw === '-.' || raw === '') {
        num = 0;
      } else {
        const parsed = Number(raw);
        num = Number.isFinite(parsed) ? parsed : 0;
      }
    }

    const rounded = Math.round(num * 1000) / 1000;
    return rounded;
  } catch (error) {
    console.error('Price formatting error:', error);
    return 0;
  }
};

export const toPrice = (value, currency = '') => {
  const rounded = toDecimal(value);
  const sign = rounded < 0 ? '-' : '';
  const fixed = Math.abs(rounded).toFixed(3);
  let [intPart, decRaw] = fixed.split('.');
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const decPart = decRaw ? decRaw.replace(/0+$/g, '') : '';
  const base = decPart ? `${sign}${formattedInt}.${decPart}` : `${sign}${formattedInt}`;
  return currency ? `${base} ${currency}` : base;
};

export const doSearch = (tableData, search, fields) => {
  if (!Array.isArray(tableData)) return tableData;
  const query = (search ?? '').trim().toLowerCase();
  if (!query) return tableData;
  const tokens = query.split(/\s+/).filter(Boolean);
  return tableData.filter((item) => {
    let haystack = '';
    try {
      haystack = JSON.stringify(item).toLowerCase();
    } catch (e) {
      haystack = Object.values(item || {})
        .map((v) => (v === null || v === undefined) ? '' : String(v))
        .join(' ').toLowerCase();
    }
    return tokens.every((t) => haystack.includes(t));
  });
}
